import { useState, useEffect } from 'react'
import { supabase } from './supabase'

export function usePartner() {
  const [partnerId, setPartnerId] = useState(null)
  const [partnerProfile, setPartnerProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchPartner()
  }, [])

  const fetchPartner = async () => {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) { setLoading(false); return }

    const { data } = await supabase.rpc('get_partner_id', { p_user_id: user.id })

    if (data) {
      setPartnerId(data)
      const { data: profile } = await supabase
        .from('profiles')
        .select('id, full_name, email')
        .eq('id', data)
        .single()
      if (profile) setPartnerProfile(profile)
    }
    setLoading(false)
  }

  return { partnerId, partnerProfile, loading }
}